<template>
  <label class="css-control css-control-primary css-checkbox">
    <input type="checkbox" class="css-control-input" :checked="currentValue" @change="save">
    <span class="css-control-indicator"></span>
    <text-alert :alert.sync="alert"></text-alert>
  </label>
</template>

<script>
import http from '../utils/http'

export default {
  props: {
    externallyAvailable: Boolean,
    productId: Number
  },
  data () {
    return {
      currentValue: this.externallyAvailable,
      alert: false
    }
  },
  created () {
    this.$root.$on('product-externally-available-updated', this.onUpdate)
  },
  destroy () {
    this.$root.$off('product-externally-available-updated', this.onUpdate)
  },
  methods: {
    save (e) {
      this.currentValue = e.target.checked
      const data = {
        externally_available: this.currentValue
      }

      this.$root.$emit('product-externally-available-updated', {
        product_id: this.productId,
        value: this.currentValue
      })

      return http.patch(`/products/${this.productId}`, data)
        .then(() => {
          this.alert = { variant: 'success', message: 'Opgeslagen' }
        })
        .catch(() => {
          this.alert = { variant: 'danger', message: 'Er is iets fout gegaan' }
        })
    },
    onUpdate (e) {
      if (this.productId === e.product_id) {
        this.currentValue = e.value
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ExternallyAvailableEditable.vue?e561958c